import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';

export const StyledReactMarkdown = styled(ReactMarkdown)`
  overflow-wrap: break-word;
`;

export const MarkdownContainer = styled.div`
  ${typography.xs.regular};

  img {
    max-width: 202px;
    display: block;
    margin: ${globalTheme.spacing.sm} auto;
  }

  pre {
    height: auto;
    min-height: 56px;
  }

  table {
    table-layout: fixed;
    width: 100%;
  }

  video {
    max-width: 100%;
  }
`;
